import React, { memo } from 'react';
import { FaEdit, FaTrash, FaToggleOn, FaToggleOff } from 'react-icons/fa';
import { OptionType } from '../../types/optionTypes';

interface OptionTypeCardProps {
  option: OptionType;
  onEdit: (option: OptionType) => void;
  onDelete: (option: OptionType) => void;
  onToggleActive: (option: OptionType) => void;
}

export const OptionTypeCard: React.FC<OptionTypeCardProps> = memo(props => {
  const { option, onEdit, onDelete, onToggleActive } = props;

  return (
    <div
      className={`bg-white border rounded-xl p-6 shadow-sm hover:shadow-md transition-all ${
        !option.is_active ? 'opacity-60 border-red-200' : 'border-gray-200'
      }`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-lg font-semibold text-gray-900">{option.display_name}</h3>
            <span className="text-sm bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
              {option.name}
            </span>
            <button
              onClick={() => onToggleActive(option)}
              className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
                option.is_active
                  ? 'bg-green-100 text-green-700 hover:bg-green-200'
                  : 'bg-red-100 text-red-700 hover:bg-red-200'
              }`}
            >
              {option.is_active ? <FaToggleOn /> : <FaToggleOff />}
              {option.is_active ? 'Aktif' : 'Pasif'}
            </button>
          </div>

          <div className="flex flex-wrap gap-2 mb-3">
            {option.options.map((opt, index) => (
              <span
                key={index}
                className={`px-3 py-1 rounded-full text-sm font-medium ${
                  opt === option.default_value
                    ? 'bg-blue-100 text-blue-700 border border-blue-300'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {opt}
                {opt === option.default_value && ' (varsayılan)'}
              </span>
            ))}
          </div>

          <div className="text-sm text-gray-500">
            Sıralama: {option.sort_order} |{new Date(option.created_at).toLocaleDateString('tr-TR')}
          </div>
        </div>

        <div className="flex items-center gap-2 ml-4">
          <button
            onClick={() => onEdit(option)}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
            title="Düzenle"
          >
            <FaEdit />
          </button>
          <button
            onClick={() => onDelete(option)}
            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
            title="Sil"
          >
            <FaTrash />
          </button>
        </div>
      </div>
    </div>
  );
});

OptionTypeCard.displayName = 'OptionTypeCard';
